import axiosInstance from './axiosInstance';

/**
 * 내 정보 조회
 * @returns {UserDetailResDto}
 */
export const getMe = async () => {
  const res = await axiosInstance.get('/api/users/me');
  return res.data;
};

/**
 * 내 정보 수정
 * @param {{ id, phone, status, deleted }} data
 */
export const updateMe = async (data) => {
  await axiosInstance.patch('/api/users/me', data);
};

/**
 * 대행(MANAGED) 계정을 정식(NORMAL) 계정으로 승격.
 * 새 계정을 만드는 게 아니라 기존 계정의 등급만 올리므로
 * 공고·지원자·메시지 데이터가 그대로 유지된다.
 */
export const upgradeManagedAccount = async () => {
  const res = await axiosInstance.post('/api/users/me/upgrade');
  return res.data;
};
